import { useDispatch, useSelector } from "react-redux";
import { WarningMessage } from "./WarningMessage";
import { OkMessage } from "./OkMessage";
import { Box, Button, Card, Grid, Typography } from "@mui/material";
import { OperationDetails } from "./OperationDetails";
import { OperationStatus } from "Enums/OperationStatus";
import { usePutOperationMutation } from "redux/api/operationApi";
import { clearCurrentOperation } from "redux/features/operationSlice";
import { useIntl } from "react-intl";

export const OperationRecomendation: React.FC<{ nextStep:  (stepIncrement?: number) => void, reset: () => void, finalStep: () => void, previousStep: () => void }> = ({ nextStep, reset, finalStep, previousStep }) => {
    const dispatch = useDispatch();
          const { formatMessage } = useIntl();
    
    const [updateOperation, { data: postedOperationData, isSuccess: isPostedOperationSuccess, error: apiError }] = usePutOperationMutation()

    const operation = useSelector((state: any) => {
        return state.operationState?.currentOperation?.data || state.operationState?.currentOperation;
    });
    const handleAbort = () => {
        const updatedOperation = {
            ...operation,
            status: OperationStatus.ABORTED,
        }
        const formData = new FormData();
        formData.append("data", JSON.stringify(updatedOperation));
        updateOperation({ id: operation.id, operationToUpdate: formData }).then((res) => {
            if ('data' in res) {
                dispatch(clearCurrentOperation());
                reset();
            }
        })
    }
    const handleNext = () => {
        if (operation?.verifiedOperation && !operation?.warningOperation) {
            nextStep(5);
        } else {
            nextStep();
        }
    }

    const handlePreviousStep=()=>{
        const updatedOperation = {
            ...operation,
            verifiedOperation: false,
            mrzChecked:false
        }
        const formData = new FormData();
        formData.append("data", JSON.stringify(updatedOperation));
        updateOperation({ id: operation.id, operationToUpdate: formData }).then((res) => {
            if ('data' in res) {
                previousStep();
            }
        })
    }

    if (!operation) return <p>{formatMessage({ id: "purpose.error" })}</p>;

    return (
        <Card sx={{ p: 2,mt:2 }}>
            {!operation?.verifiedOperation ? (
                <WarningMessage />
            ) : (<OkMessage />)}
            <OperationDetails operation={operation} />
            {!operation?.verifiedOperation ? (<Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '20px',
                }}
            >
                <Typography sx={{ marginBottom: '16px', fontSize: '18px' }}>
                {formatMessage({ id: "operation.recommendation.continue.question" })}
                </Typography>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '8px', // Espaciado entre los botones
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={handleNext}
                        sx={{
                            backgroundColor: 'black',
                            color: 'white',
                            borderRadius: "15px",
                            padding: '10px 20px',
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: '#333',
                            },
                        }}
                    >
                        {formatMessage({ id: "compilance.ok.option" })}
                    </Button>
                    <Button
                        onClick={handleAbort}
                        variant="outlined"
                        sx={{
                            border: '2px solid black',
                            backgroundColor: 'white',
                            color: 'black',
                            borderRadius: "15px",
                            padding: '10px 20px',
                            fontWeight: 'bold',
                            '&:hover': {
                                backgroundColor: '#f2f2f2',
                            },
                        }}
                    >
                        {formatMessage({ id: "operation.recommendation.not.continue" })}
                    </Button>
                </Box>
            </Box>) : (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '20px',
                    }}
                >
                    <Grid container spacing={2} justifyContent="space-between" >
                        <Grid item xs={12} lg={6}>
                            <Button
                                variant="outlined"
                                color="secondary"
                                fullWidth
                                onClick={handlePreviousStep}
                                sx={{
                                    mt: 2,
                                    backgroundColor: "#FFF",
                                    display: {
                                        xs: "none", // Ocultar en pantallas pequeñas (móviles)
                                        sm: "none", // Ocultar en tablets
                                        md: "block", // Mostrar en pantallas medianas y grandes
                                    },
                                }}
                            >
                                {formatMessage({ id: "buttons.back" })}
                            </Button>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Button
                                variant="contained"
                                onClick={handleNext}
                                fullWidth
                                sx={{
                                    mt: 2,
                                    backgroundColor: "black",
                                    color: "white",
                                    fontWeight: "bold",
                                    "&:hover": {
                                        backgroundColor: "#333",
                                    },
                                    mb: 2,
                                }}
                            >
                                {formatMessage({ id: "buttons.continue" })}
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            )
            }

        </Card>
    );
};
